import script from "./CommLogs.vue?vue&type=script&setup=true&lang=js"
export * from "./CommLogs.vue?vue&type=script&setup=true&lang=js"

import "./CommLogs.vue?vue&type=style&index=0&id=45574da0&scoped=true&lang=css"

import exportComponent from "/var/www/html/a4m/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45574da0"]])

export default __exports__